import IRecibo from "../interfaces/IRecibo";
import { useAuth } from "../providers/auth";
import util from "../utilities/util";

const generateReciboOutrosRecebimentosHtml = (dados: IRecibo): string => {

  const logoHtml = dados.NaoImprimeLogomarca
    ? ''
    : `<img src="https://bancariospa.org.br/wp3/wp-content/uploads/2022/06/LOGO-SOPHOS-V.png" alt="Logo" width="auto" height="50">`;

  return `
<!DOCTYPE html>
<html lang="pt-BR">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Recibo</title>
        <style>
            @media print {
                @page {
                    size: A4;
                    margin: 0;
                }
                body {
                    margin: 10mm;
                }
            }
            
            body {
                font-family: Courier New, Arial, sans-serif;
                font-size: 8px!important;
                line-height: 1;
                margin: 0;
                padding: 0;
            }
            
            .receipt-container {
                display: flex;
                max-width: 800px;
                margin: 0 auto;
                border: 1px solid #000;
            }
            
            .header {
                display: flex;  
                width: 100%;              
            }
            
            .logo-container {
                padding: 10px;
            }
            
            .logo {
                width: 100px;
                height: auto;
            }
            
            .title-container {
                width: 100%;
                padding: 10px;
                text-align: center;
                display: flex;
                border-bottom: 1px solid #000;
            }
            
            .company-name {
                font-weight: bold;
                font-size: 18px;
                margin-bottom: 20px;
            }
            
            .receipt-title {
                font-size: 24px;
                font-weight: bold;
                margin-bottom: 0;
            }
            
            .receipt-number {
                font-size: 24px;
                font-weight: bold;
                margin-top: 5px;
            }
            
            .content {
                display: flex;
            }
            
            .left-content {
                width: 25%;
                padding: 2px;
                border-right: 1px solid #000;
            }

            .right-column {
                width: 75%;
                display: flex;
                flex-direction: column;
            }
            
            .right-content {
                width: 75%;
                display: flex;
                flex-direction: column;
                flex: 1;
            }
            
            .right-top {
                padding: 2px;
            }
            
            .right-bottom {
                display: flex;
                flex: 1;
            }
            
            .remission-info {
                width: 100%;                
                padding: 8px;
            }
            
            .values-info {
                width: 25%;
                padding: 2px;
                justify-content: space-between;
                display: flex;
                flex-direction: column;
            }
            
            .field {
                margin-bottom: 5px;
            }
            
            .field-label {
                color: #666;
                font-size: 10px;
            }
            
            .field-value {
                font-size: 10px;
            }
            
            .receipt-text {
                margin: 15px 0;
            }
            
            .cnpj-footer {
                margin-bottom: 6px;
                text-align: center;
                font-size: 10px;
            }
            
            .address-footer {
                text-align: center;
                padding: 10px;
                border-top: 1px solid #000;
                font-size: 10px;
            }
            
            .school-info {
                margin-bottom: 10px;
            }
            
            .school-name {
                font-weight: bold;                
            }
            
            .school-cnpj {
                font-size: 10px;
            }
            
            .remission-title {
                font-weight: bold;
            }
            
            .values-table {
                width: 100%;
            }
            
            .values-table td {
                padding: 3px 0;
            }
            
            .values-table .value-column {
                text-align: right;
                font-size: 10px;
            }
            
            .total-row {
                font-weight: bold;
            }
            
            .paid-row {
                font-weight: bold;
            }
            
            .signature-line {
                margin-top: 80px;
                border-top: 1px solid #000;
                width: 70%;
            }

            .bold {
                font-weight: bold;
            }

            .center {
                text-align: center;
            }

            div {
                min-height: 12px;
            }

            .label-small {
                font-size: 8px;
            }

            .content-right{
                display: flex;
                flex-direction: row;
                width: 100%;                
                flex: 1;
            }
        </style>
    </head>
    <body>
        <div class="receipt-container">
            <div class="left-content">
                <div class="logo-container">
                    ${logoHtml}
                </div>
                <div>
                    <div class="school-name">${dados.RazaoSocial.toUpperCase()}</div>
                    <div class="school-cnpj">${dados.CNPJEmpresa}</div>
                </div>
                    
                <div class="remission-title" style="">${dados.Reemissao}</div>
                <div class="remission-title" style="text-align: center;">N°${dados.NumeroRecibo}</div>
                    
                <div class="field">
                    <div class="field-value">${dados.Nome}</div>
                    <div class="field-label">MATRÍCULA: ${dados.Matricula}</div>
                </div>
                    
                <div class="field">
                    <div class="field-label">FORMA DE PAGAMENTO: ${dados.FormaPagamento}</div>
                    <div class="field-label">DATA DE PAGAMENTO: ${dados.DataPagamento}</div>
                </div>

                <div class="field">
                    <div class="field-label">CONTA: ${dados.PlanoConta}</div>
                </div>

                <div class="values-table">
                    <table width="100%">
                        <tr>
                            <td class="field-label label-small" align="right" width="60%">VALOR:</td>
                            <td class="value-column" >${dados.Valor}</td>
                        </tr>
                        <tr>
                            <td class="field-label label-small" align="right" width="60%">MULTA:</td>
                            <td class="value-column">${dados.Multa}</td>
                        </tr>
                        <tr>
                            <td class="field-label label-small" align="right" width="60%">JUROS:</td>
                            <td class="value-column">${dados.Juros}</td>
                        </tr>
                        <tr>
                            <td class="field-label label-small" align="right" width="60%">DESCONTO:</td>
                            <td class="value-column">${dados.Desconto}</td>
                        </tr>
                        <tr class="total-row">
                            <td class="field-label label-small" align="right" width="60%">*TOTAL PAGO:</td>
                            <td class="value-column">${dados.Total}</td>
                        </tr>    
                    </table>
                    </br>
                    </br>
                    </br>
                </div>
            </div>
            <div class="right-column">
                <div class="header">                
                    <div class="title-container">
                        ${logoHtml}
                        <div style="flex-grow: 1; text-align: left;margin-left: 10px;">
                        <div class="bold">${dados.RazaoSocial.toUpperCase()}</div>
                        <div class="bold"></div>
                        <div class="bold"></div>
                        <div style="display: flex; flex-direction: row;">
                        <div class="bold center" style="display: flex; flex: 1;font-size: 20px;">${dados.TituloRecibo}</div>
                            <div class="bold" style="text-align: right;display: flex;font-size: 20px;">N°${dados.NumeroRecibo}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-right">
                <div class="right-content">
                    <div class="right-top">
                        <table width="100%">
                            <tr>
                                <td width="50%"><span class="field-label">BELÉM(PA),</span> ${dados.DataPagamento}</td>
                                <td rowspan="4" style="text-align: center;">
                                    <div class="remission-title">${dados.Reemissao}</div>
                                </td>
                            </tr>
                        </table>
                        <table width="100%">
                            <tr>
                                <td><span class="field-label">DATA DE PAGAMENTO.:</span> ${dados.DataFaturamento}</td>
                            </tr>
                            <tr>
                                <td><span class="field-label">MATRÍCULA.:</span> ${dados.Matricula} - ${dados.Nome}</td>
                            </tr>
                            <tr>
                                <td><span class="field-label">TURMA:</span> ${dados.Turma}</td>
                            </tr>
                            <tr>
                                <td><span class="field-label">FORMA DE PAGAMENTO.:</span> ${dados.FormaPagamento}</td>
                            </tr>
                            <tr>
                                <td><span class="field-label">CONTA:</span> ${dados.PlanoConta}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="right-bottom">
                        <div class="remission-info">
                            <div class="receipt-text" style="text-indent: 30px;">
                                Recebi de <strong>${dados.ResponsavelFin?.toUpperCase()}</strong>, ${dados.CNPJ.length < 14 ? `CPF: ${dados.CNPJ}` : `CNPJ: ${dados.CNPJ}`} a importância de R$ ${dados.Valor} (${dados.ValorExtenso}) referente a ${dados.Referencia}.
                            </div>                                                
                        </div>                    
                    </div>
                    <div class="address-footer">
                        ${dados.Endereco}
                    </div>
                </div>
                <div class="values-info" style="border-left: 1px solid #000;">
                    <table class="values-table">
                        <tr>
                            <td class="field-label">VALOR:</td>
                            <td class="value-column">${dados.Valor}</td>
                        </tr>
                        <tr>
                            <td class="field-label">MULTA:</td>
                            <td class="value-column">${dados.Multa}</td>
                        </tr>
                        <tr>
                            <td class="field-label">JUROS:</td>
                            <td class="value-column">${dados.Juros}</td>
                        </tr>
                        <tr>
                            <td class="field-label">DESCONTO:</td>
                            <td class="value-column">${dados.Desconto}</td>
                        </tr>
                        <tr class="total-row">
                            <td class="field-label">*TOTAL PAGO:</td>
                            <td class="value-column">${dados.Total}</td>
                        </tr>                                
                    </table>
                    <div class="cnpj-footer">                                
                        ${dados.Autenticacao || ''}
                    </div>
                </div>
            </div>
            </div>         
        </div>
    </body>
</html>`;
};

export { generateReciboOutrosRecebimentosHtml };